// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1VUu5","row":"styles_row__nu4cM"};